// extracted by mini-css-extract-plugin
module.exports = {"inputField":"inputField_inputField__2Ig3O","inputMessage":"inputField_inputMessage__3QqRm"};